import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'
export default async function (data) {
	const node = data.node;
	const title = node.title;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme)
	const ex1 = await getThemePic(data?.customTheme, 'ex-1')


	return {
		"id": id,
		"elements": [
			{
				"type": "image",
				"id": "1swhZ8wSfj",
				"src": ex1,
				"width": 607.3488471275006,
				"height": 458.4037727128992,
				"left": 393.0511528724994,
				"top": 0,
				"fixedRatio": true,
				"rotate": 0
			},
			{
				"type": "shape",
				"id": "RfVWeER5oX",
				"width": 1002.5733333333333,
				"height": 563.68,
				"left": -6.524909333074117,
				"top": 0,
				"viewBox": [
					751.93,
					422.76
				],
				"path": " M751.9289698162729,421.8749042963127 L751.9289698162729,416.67468309834044 L730.8867290026246,411.12959032464806 C516.6514107611548,349.331009847343 473.70948162729655,175.8916562683629 368.7502460629921,145.56173331415994 C256.79371719160105,113.20988593911952 156.97465551181102,190.09308248871824 1.6304133858267715,0 L0,422.755249343832 L751.9289698162729,421.8749042963127z",
				"fill": "#e64239",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#7f1610",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 16px;\"><span style=\"font-family: 微软雅黑;\">&nbsp;</span></span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": true,
				"special": true
			},
			{
				"type": "shape",
				"id": "vkzJHodMPQ",
				"width": 1000,
				"height": 214.64,
				"left": -6.524909333074117,
				"top": 349.03999999999996,
				"viewBox": [
					750,
					160.98
				],
				"path": " M0,160.98129921259843 L0,16.254593175853017 C84.59694881889763,-36.51935695538058 163.47399934383202,56.00647965879265 255.67962598425197,57.10900590551181 C379.67872375328085,50.87458989501312 439.0538057742782,-2.5944061679790025 553.2340059055118,22.86991469816273 C667.4142060367454,48.334235564304464 711.3135662729659,109.23761482939632 750.0000820209974,160.98129921259843 L0,160.98129921259843z",
				"fill": "#ff8181",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#7f1610",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 微软雅黑;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "middle"
				},
				"flipH": true,
				"flipV": false,
				"special": true
			},
			{
				"type": "shape",
				"id": "oTrZJyJXii",
				"width": 1001.1999999999999,
				"height": 200.54666666666665,
				"left": -0.799999999999983,
				"top": 362.58666666666664,
				"viewBox": [
					750.9,
					150.41
				],
				"path": " M0,150.40780839895012 L0,15.186967355555115 C84.69800441501457,-34.12071135383085 163.6692778105374,52.32789089678395 255.9850490211289,53.358001582201815 C380.13227036811134,47.53307127431517 439.5782791115484,-2.4240017177840096 553.8948736204766,21.367784735535245 C668.2114681294047,45.1595711888545 712.1632685077315,102.06272605316583 750.895997375328,150.40780839895012 L0,150.40780839895012z",
				"fill": "rgba(242,242,242,1)",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#7f1610",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: 微软雅黑;\"><span style=\"color: rgba(217,203,203,1);\">&nbsp;</span></span></span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "middle"
				},
				"flipH": true,
				"flipV": false,
				"special": true
			},
			{
				"type": "shape",
				"id": "q0DIWKsBWK",
				"width": 332.02666666666664,
				"height": 124,
				"left": -6.524909333074117,
				"top": 0,
				"viewBox": [
					249.02,
					93
				],
				"path": " M0,93.00295275590551 L0,0 C43.45859130746377,19.00289387536138 108.57149550908946,-6.352026720173082 157.89480979720364,14.690730934455738 C207.21812408531784,35.73348858908456 190.67670945660245,69.14839463221269 249.0225557742782,93.00295275590551 L0,93.00295275590551z",
				"fill": "#ff8181",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#7f1610",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 微软雅黑;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": true,
				"special": true
			},
			{
				"type": "text",
				"id": "WogSUrED1m",
				"width": 474.58666666666664,
				"height": 75.09375,
				"left": 78.96357401250442,
				"top": 188.53931204650482,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": `<p style=\"\"><span style=\"font-size: 55.1px;\"><span style=\"font-family: 方正正黑简体;\"><span style=\"color: rgba(255,255,255,1);\">${title}</span></span></span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "WHIC9TC7Fb",
				"width": 336.26666666666665,
				"height": 40,
				"left": 87.57615122430629,
				"top": 297.1804813583422,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"\"><span style=\"font-size: 18px;\"><span style=\"font-family: 微软雅黑;\"><span style=\"color: rgba(255,255,255,1);\">宣讲人：ChatGpt&nbsp; 时间：20XX.XX</span></span></span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "CO2hiIQCSp",
				"left": 236.89333333333332,
				"top": 432.6329315914937,
				"width": 782.6516529703281,
				"height": 163,
				"content": "<p style=\"\" class=\"\"><span style=\"font-size: 72px;\"><span style=\"color: rgb(215, 174, 174);\">FASHION MAKEUP</span></span></p><p style=\"\"><br class=\"ProseMirror-trailingBreak\"></p>",
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"vertical": false
			}
		],
		background
	};

}